import { graphql } from 'gatsby';
import React from 'react';

import { IMeetingPlaceLinkToAnyPage } from '../../../queries/fragments/meetingPlaceLinkToAnyPage';
import EditorialPageFullWidthImageWrapper, {
  FullWidthImageBlockProps,
} from '../../page-components/editorial-page-full-width/editorial-page-full-width-image-wrapper';
import EditorialPageFullWidthTextWrapper, {
  FullWidthTextBlockProps,
} from '../../page-components/editorial-page-full-width/editorial-page-full-width-text-wrapper';
import EditorialPageFullWidthWrapper from '../../page-components/editorial-page-full-width/editorial-page-full-width-wrapper';

export interface FullWidthTextAndImageProps
  extends FullWidthTextBlockProps,
    FullWidthImageBlockProps {
  id?: string;
}

export interface LinkProps {
  cardLink?: IMeetingPlaceLinkToAnyPage;
  externalLink?: string;
}

const EditorialFullWidthTextAndImageBlock = ({
  landscapeImage,
  portraitImage,
  imageAlignment,
  body,
  cardLink,
  externalLink,
  topBlock,
  cardType,
  textItem,
}: FullWidthTextAndImageProps) => {
  const renderLayout =
    landscapeImage || portraitImage ? (
      //Renders a component with an Image & Text
      <EditorialPageFullWidthImageWrapper
        portraitImage={
          portraitImage && landscapeImage
            ? undefined
            : portraitImage && !landscapeImage
              ? portraitImage
              : undefined
        }
        landscapeImage={
          landscapeImage && portraitImage
            ? undefined
            : landscapeImage && !portraitImage
              ? landscapeImage
              : undefined
        }
        imageAlignment={imageAlignment}
        cardType={cardType}
        cardLink={cardLink}
        topBlock={topBlock}
        externalLink={externalLink}
      >
        <EditorialPageFullWidthWrapper
          isImage={portraitImage || landscapeImage ? true : false}
          cardType={cardType}
          topBlock={topBlock ? topBlock : null}
          body={body}
        >
          <EditorialPageFullWidthTextWrapper
            body={body}
            cardType={cardType}
            textItem={textItem}
            isImage={portraitImage || landscapeImage ? true : false}
          />
        </EditorialPageFullWidthWrapper>
      </EditorialPageFullWidthImageWrapper>
    ) : (
      //Renders a component with Text
      <EditorialPageFullWidthWrapper
        isImage={portraitImage || landscapeImage ? true : false}
        cardLink={cardLink}
        externalLink={externalLink}
        cardType={cardType}
        topBlock={topBlock ? topBlock : null}
      >
        <EditorialPageFullWidthTextWrapper
          body={body}
          cardType={cardType}
          textItem={textItem}
          isImage={portraitImage || landscapeImage ? true : false}
        />
      </EditorialPageFullWidthWrapper>
    );

  return <>{renderLayout}</>;
};

export default EditorialFullWidthTextAndImageBlock;

export const query = graphql`
  fragment BlockEditorialFullWidthTextAndImage on ContentfulBlockEditorialFullWidthImageAndText {
    blocktype: __typename
    cardType
    imageAlignment
    title
    preamble
    body {
      raw
      references {
        ...Asset
        ...Entry
      }
    }
    cardLink {
      ...MeetingPlaceLinkToAnyPage
    }
    externalLink
    landscapeImage {
      description
      gatsbyImageData(width: 1500, height: 1000, formats: AVIF)
    }
    portraitImage {
      description
      gatsbyImageData(width: 1200, height: 1600, formats: AVIF)
    }
  }
`;
